<template>
    <div>
        <PageTitle :pages="pages" :title="titles.clientList"/>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{title}}</h4>
                <Tab v-if="subscription" :codePromo="codePromo" :currentTabComponent="tabs[0].component"
                     :form="subscription"
                     :show="showTab"
                     :tabs="tabs"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import Tab from '../../common/Tab';
    import PageTitle from '@/components/common/PageTitle';
    import {titles} from '../../../utils/general/titles';
    import {name} from '../../../utils/general/routers';
    import {subscription} from '../../shared/models/subscription';
    import {getClientById} from '../../shared/services/user.service';

    export default {
        components: {PageTitle, Tab},
        data() {
            return {
                titles,
                currentTab: null,
                showTab: true,
                codePromo: false,
                title: titles.clientAddExpression,
                pages: [],
                subscription: null,
                tabs: []
            };
        },
        created() {
            if (this.$route.params.id) {
                getClientById(this.$route.params.id).then(response => {
                    this.subscription = response.data;
                });
                if(this.$cookies.isKey('commercialItemIsEditable')){
                    this.$cookies.set('editClientPage', true);
                }
                this.title = titles.clientDetailExpression;
                this.tabs = [
                    {
                        name: 'Client',
                        component: 'ClientInfo'
                    },
                    {
                        name: 'Organisations',
                        component: 'organisations-table'
                    }
                ];
            } else {
                this.subscription = subscription();
                this.tabs = [
                    {
                        name: 'Client',
                        component: 'ClientInfo'

                    },
                    {
                        name: 'Organisation',
                        component: 'OrganisationInfo'
                    },
                    {
                        name: 'Pack',
                        component: 'PackInfo'
                    }
                ];
            }
            this.currentTab = this.$route.params.goToTab ? this.$route.params.goToTab : this.tabs[0].component;
            this.tabSelected = this.tabs[0].component;
            this.pages.push(
                {
                    name: titles.network,
                    router: name.network,
                    active: false
                },
                {
                    name: titles.clientList,
                    router: name.clientList,
                    active: false
                },
                {
                    name: this.title,
                    router: null,
                    active: true
                }
            );
        },
        validations: {
            subscription: {
                organisation: {required},
                packCountryDomain: {required}
            }
        }
    };
</script>
<style lang="scss" scoped>
    .met-pro-bg {
        background-image: url("../../../assets/images/pro.jpg");
        background-repeat: no-repeat;
        background-size: cover;
    }

    a {
        cursor: pointer;
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }

    .btn-standard-gradient {
        box-shadow: none;
    }
</style>
